import { useState } from 'react';
import { AppPageHeader } from '@/components/_common';
import { useHelpAreas } from '@/core/domain/helpcenter/HelpAreas/HelpAreas.hooks';
import { HelpAreaQuery } from '@/core/domain/helpcenter/HelpAreas/HelpAreas.types';
import { useDebounce } from '@/hooks';
import { Card, Col, Empty, Row, Typography } from 'antd';
import HelpCenterAreaCard from '../HelpCenterAreaCard';
import SkeletonCustom from '@/components/_common/SkeletonCustom';

export default function HelpAreaList() {
  const [queryParams, setQueryParams] = useState<HelpAreaQuery>();

  const queryDebounce = useDebounce(queryParams, 500);
  const helpAreas = useHelpAreas(queryDebounce);

  return (
    <>
      <Typography.Title
        level={3}
        style={{ marginTop: 100, marginBottom: 50, textAlign: 'center' }}
      >
        Todas as áreas
      </Typography.Title>

      <AppPageHeader
        onSearch={(value) => setQueryParams({ name: value })}
        searchValue={queryParams?.name}
      />

      <SkeletonCustom
        loading={helpAreas.isLoading}
        skeletonType="INPUT"
        style={{ height: 150, marginBottom: 24 }}
      />

      {!helpAreas.data?.length && !helpAreas.isLoading && (
        <Card>
          <Empty
            description={
              <>
                Nenhuma área encontrado
                {queryDebounce?.name && (
                  <>
                    {' '}
                    para <strong>"{queryDebounce.name}"</strong>
                  </>
                )}
              </>
            }
          />
        </Card>
      )}

      {!!helpAreas.data?.length && (
        <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
          {helpAreas.data
            .map((area) => (
              <Col span={24} md={12} lg={8} key={area.id}>
                <HelpCenterAreaCard area={area} />
              </Col>
            ))
            .reverse()}
        </Row>
      )}
    </>
  );
}
